<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{ $t('texts.applications') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            color="transparent"
            active-class="text--primary"
            :show-arrows="$vuetify.breakpoint.smAndDown"
          >
            <v-tab ripple :to="{ name: 'employee.application.list.all' }">
              {{ $t('texts.all') }}
            </v-tab>
            <v-tab ripple :to="{ name: 'employee.application.list.open' }">
              {{ $t('texts.open') }}
            </v-tab>
            <v-tab ripple :to="{ name: 'employee.application.list.draft' }">
              {{ $t('texts.draft') }}
            </v-tab>
            <v-tab ripple :to="{ name: 'employee.application.list.completed' }">
              {{ $t('texts.completed') }}
            </v-tab>
            <v-tabs-items v-model="active">
              <v-card>
                <v-card-text>
                  <router-view/>
                </v-card-text>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');

export default {
  name: 'EmployeeApplication',
  data() {
    return {
      active: null,
    };
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
